._1ttn03d0 {
  height: fit-content;
  padding: 28px 0;
}